export default {"src":"/_next/static/media/on-demand.331c20c7.svg","height":148,"width":282,"blurWidth":0,"blurHeight":0};